module.exports = __webpack_public_path__ + "static/media/4.4020f4e9.png";